import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-lg" }
const _hoisted_2 = { class: "stack-lg" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_PosterCard = _resolveComponent("PosterCard")!
  const _component_Col = _resolveComponent("Col")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ArticleCard = _resolveComponent("ArticleCard")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Grid, {
      size: "lg",
      class: "mb-xl"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.trans("general.search")), 1),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_SearchInput, {
            ref: "searchInput",
            variant: "dark",
            name: "q",
            class: "mb-3xl",
            modelValue: _ctx.searchQuery,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            placeholder: _ctx.trans('general.search_for_movies_series_and_news'),
            onKeyup: _withKeys(_ctx.handleKeyEnter, ["enter"])
          }, null, 8, ["modelValue", "placeholder", "onKeyup"]),
          (_ctx.$route.query.q)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.transChoice("general.search_results_count", _ctx.searchResultsCount)), 1))
            : _createCommentVNode("", true),
          (_ctx.searchResults.medias.length)
            ? (_openBlock(), _createBlock(_component_Row, { key: 1 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults.medias, (media) => {
                    return (_openBlock(), _createBlock(_component_Col, {
                      key: media._id,
                      size: ['1/2', '1/3@sm', '1/4@md', '1/5@lg']
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_PosterCard, { media: media }, null, 8, ["media"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.searchResults.articles.length)
            ? (_openBlock(), _createBlock(_component_Row, { key: 2 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults.articles, (article) => {
                    return (_openBlock(), _createBlock(_component_Col, {
                      key: article._id,
                      size: ['1/1', '1/2@md', '1/3@lg']
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArticleCard, { article: article }, null, 8, ["article"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}